export const CREATE_STOCKHISTORY36376 = "CREATE_STOCKHISTORY36376";
export const UPDATE_STOCKHISTORY36376 = "UPDATE_STOCKHISTORY36376";
export const DELETE_STOCKHISTORY36376 = "DELETE_STOCKHISTORY36376";
export const FETCH_STOCKHISTORY36376 = "FETCH_STOCKHISTORY36376";
export const LISTEN_TO_SELECTED_STOCKHISTORY36376 =
  "LISTEN_TO_SELECTED_STOCKHISTORY36376";
export const FILTER_STOCKHISTORY36376 = "FILTER_STOCKHISTORY36376";
